module.exports = __webpack_public_path__ + "img/gamechanger-logo-white.da241bd7.svg";